// @ts-strict-ignore
import { ProjectHeadVO } from './vo/project.vo';

export enum ProjectChangedType {
  ConfigurationDeleted = "ConfigurationDeleted",
  ProjectCleared = "ProjectCleared",
  ProjectReset = "ProjectReset",
  ProjectRenamed = "ProjectRenamed",
  ProjectRefreshed = "ProjectRefreshed",
  ProjectTypeChanged = "ProjectTypeChanged",
  CurrentProjectChanged = "CurrentProjectChanged",
  ProjectChange = "ProjectChange",
  McsGdsProjectCreated = "McsGdsProjectCreated",
  MaxMountingRailUpdated = "MaxMountingRailUpdated",
  TexturesUpdated = "TexturesUpdated",
  FinalizationStateChanged = "FinalizationStateChanged",
  CAEProjectSaved = "CAEProjectSaved",
}

export class ProjectChanged {
  constructor(public projectHeadVO: ProjectHeadVO,
              public type: ProjectChangedType,
              // Workaround for GlobalContainer
              public articleUsageIdsToRefresh: string[] = null) {
  }
}
